// Module
var code = `<ex-mono-occurrence-ecran formulaire="vm.formulaireIpm" mono-occurrence-options="vm.monoOccurrenceOptions"> </ex-mono-occurrence-ecran>`;
// Exports
module.exports = code;